<template>
  <v-card>
    <v-card-title>
      {{ $t("noCurrentAuditPeriodInfo.title") }}
    </v-card-title>

    <v-card-text>
      {{ $t("noCurrentAuditPeriodInfo.text") }}
    </v-card-text>

    <v-card-actions>
      <v-btn :to="{ name: 'bookings' }" color="secondary">
        {{ $t("noCurrentAuditPeriodInfo.cta") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>
